import { COLORS, SCREEN_LG } from "shared/consts";
import { toEm, toRem } from "shared/helpers";
import styled, { css } from "styled-components";

type CalendarCalendarWrapperProps = {
  $isVidget?: boolean;
  $selectedDateSelector?: string;
}
export const CalendarCalendarWrapper = styled.div<CalendarCalendarWrapperProps>`
  --minus-height: ${toRem(109)};
  --fc-border-color: ${COLORS.BORDER.MUTED};
  --fc-event-text-color: ${COLORS.FG.DEFAULT};
  --fc-event-bg-color: ${COLORS.BG.SURFACE4};
  --fc-event-border-color: ${COLORS.BG.SURFACE4};
  --fc-list-event-hover-bg-color: ${COLORS.ACCENT.DEFAULT};
  --fc-event-border-color: ${COLORS.ACCENT.DEFAULT};
  

  ${props => props.$isVidget && css`
    height: 100%;
    padding: ${toRem(16)};
  `}

  .fc {
    height: ${props => props.$isVidget ? '100%' : `calc(100dvh - var(--minus-height))`} !important;
    max-width: 100%;

    /* ${props => props.$isVidget && css`
      @media (width >= ${toEm(1351)}){
        min-width: ${toRem(363)};
      }
    `} */
  }

  .fc-event {
    cursor: pointer;

    @media (any-hover: hover){
      &:hover{
        --fc-event-border-color: ${COLORS.BG.PAGE};
      }
    }
  }

  .fc-scroller {
    ${props => props.$isVidget && css`
      scrollbar-width: none;
    `}
  }

  .fc-list-event-dot {
    transition: border-color 0.3s ease 0s;
  }

  .fc .fc-view-harness {
    height: calc(100dvh - var(--minus-height)) !important;
  }

  .fc .fc-timegrid-axis-frame {
    justify-content:center;align-items: center;
  }
  .fc .fc-timegrid-axis-cushion {
    text-align: center;
    font-size: ${toRem(14)};
    color: ${COLORS.FG.MUTED};
  }
  .fc .fc-timegrid-slot-label {
    display: flex;
    justify-content:center;align-items: center;
  }
  .fc .fc-timegrid-slot-label-cushion {
    font-size: ${toRem(14)};
    color: ${COLORS.FG.MUTED};
  }
  .fc-theme-standard th {
    --fc-border-color: transparent;
  }
  .fc-theme-standard .fc-scrollgrid,
  .fc-theme-standard .fc-timegrid-slot-label {
    border: none;
  }
  .fc .fc-daygrid-day.fc-day-today {
    --fc-today-bg-color: transparent
  }
  .fc .fc-timegrid-col.fc-day-today {
    --fc-today-bg-color: transparent
  }
  .fc .fc-cell-shaded {
    --fc-neutral-bg-color: transparent;
  }

  .fc .fc-scrollgrid-sync-table {
    border-top: ${toRem(1)} solid ${COLORS.BORDER.MUTED};
  }

  .fc-event-time, .fc-event-title {
    padding: ${toRem(1.5)} ${toRem(6)};
    font-size: ${toRem(11)};
    line-height: ${16 / 11};
  }

 .fc-timegrid-event-short .fc-event-main-frame * {
    padding: 0 !important;
    line-height: 1 !important;
    margin: 0 !important;
  }

  .fc-timegrid-event-harness-inset .fc-timegrid-event, .fc-timegrid-event.fc-event-mirror, .fc-timegrid-more-link {
    box-shadow: none;
    transition: background-color 0.3s ease 0s, border-color 0.3s ease 0s;

    @media (any-hover: hover){
      &:hover{
        --fc-event-bg-color: ${COLORS.ACCENT.DEFAULT};
        --fc-event-border-color: ${COLORS.ACCENT.DEFAULT};
      }
    }
  }

  .fc-h-event {
    cursor: pointer;
    transition: background-color 0.3s ease 0s, border-color 0.3s ease 0s;

    @media (any-hover: hover){
      &:hover{
        --fc-event-bg-color: ${COLORS.ACCENT.DEFAULT};
        --fc-event-border-color: ${COLORS.ACCENT.DEFAULT};
      }
    }
  }

  .fc-list-day > * {
    --fc-page-bg-color: transparent;
  }

  .fc-theme-standard .fc-list {
    border: none;
  }

  .fc .fc-daygrid-day {
    padding: ${toRem(4)};
  }

  .fc .fc-daygrid-day-number {
    font-size: ${toRem(12)};
    line-height: ${14 / 12};
    display: inline-flex;
    justify-content:center;align-items: center;
    padding: ${toRem(2)} ${toRem(4)} 0;
    border-radius: ${toRem(4)};
    vertical-align: middle;
  }

  .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {
    font-weight: 500;
    color: ${COLORS.ACCENT.DEFAULT};
  }

  .fc .fc-daygrid-day[data-date="${props => props.$selectedDateSelector}"] .fc-daygrid-day-number {
    font-weight: 500;
    background-color: ${COLORS.ACCENT.DEFAULT};
    color: ${COLORS.STATIC.WHITE};
  }

  @media (width < ${toEm(SCREEN_LG)}){
    --minus-height: ${toRem(178)};

    .fc-col-header-cell-cushion {
      width: 100%;
    }
  }
`

export const CalendarCalendarWidgetTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${toRem(8)};
  font-weight: 700;
  font-size: ${toRem(16)};
  line-height: ${24 / 16};
  &:not(:last-child) {margin-bottom: ${toRem(16)};}

  a {
    margin-left: auto;
    display: flex;
    align-items: center;
    font-weight: 400;
    color: ${COLORS.FG.SOFT};
    cursor: pointer;
  }
`
type DayHeaderContentWrapperProps = {
  $isVidget?: boolean;
}
export const DayHeaderContentWrapper = styled.div<DayHeaderContentWrapperProps>`
  display: flex;
  align-items: center;
  gap: ${toRem(6)};
  height: ${toRem(44)};
  font-weight: 500;
  font-size: ${toRem(14)};
  line-height: ${20 / 14};
  background-color: ${props => props.$isVidget ? COLORS.BG.PAGE: 'transparent'};

  span {
    color: ${COLORS.FG.SOFT};
  }

  p {
    display: flex;
    justify-content:center;
    align-items: center;
    flex: 0 0 ${toRem(28)};
    height: ${toRem(28)};
    border-radius: ${toRem(8)};
    min-width: ${toRem(28)};
    color: ${COLORS.FG.DEFAULT};

    &._active {
      background-color: ${COLORS.ACCENT.DEFAULT};
      color: ${COLORS.STATIC.WHITE};
    }
  }

  @media (width < ${toEm(SCREEN_LG)}){
    flex-direction: column;
    align-items: stretch;
    height: ${toRem(64)};
    width: 100%;
  }
`

export const CalendarCalendarHead = styled.div`
  display: flex;
  align-items: center;
  gap: ${toRem(12)};
  justify-content: space-between;
  padding: ${toRem(16)};

  --button-ghost-accent-label-color-default: ${COLORS.FG.DEFAULT};

  .button--ghost {
    text-transform: capitalize;
    --button-m-padding-left: 0;
    --button-m-padding-right: 0;
  }
`

export const CalendarCalendarTitle = styled.h2`
  display: flex;
  gap: ${toRem(8)};
  font-weight: 500;
  font-size: ${toRem(22)};

  span {
    text-transform: capitalize;
  }

  i {
    color: ${COLORS.FG.MUTED};
  }
`

export const CalendarCalendarActions = styled.div`
  display: flex;
  gap: ${toRem(8)};

  --button-m-padding-left: ${toRem(6)};
  --button-m-padding-right: ${toRem(6)};
  --input-primary-bg-color-default: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  --input-m-border-width: 0;

  .input {
    min-width: ${toRem(150)};
    width: ${toRem(150)};
  }
`

export const DrawerDateWrapper = styled.div`
  display: flex;
  justify-content:center;align-items: center;
  padding: ${toRem(16)};
`